import { isSheerIdFreePlan } from 'Utils/SheerIdHelpers';
import { isVAFreePlan } from './VeteransAdvHelpers';

export function getPaymentTotalPrice({ selectedPlan, selectedPlanPrice, promoCode, totalTax }) {
  const isFreeSheerId = isSheerIdFreePlan(selectedPlan?.packageID);
  const isFreePlan = isFreeSheerId || isVAFreePlan(selectedPlan?.planId);

  const priceWithPromoCode = promoCode.priceToBeCharged > 0 ? promoCode.priceToBeCharged : 0;
  const totalPackagePrice = priceWithPromoCode || selectedPlanPrice;
  let totalPrice = (totalPackagePrice + totalTax).toFixed(2) || (0).toFixed(2);

  if (isFreePlan) {
    totalPrice = (0).toFixed(2);
  }

  return totalPrice;
}
